import { render, staticRenderFns } from "./HeaderControlsProject.vue?vue&type=template&id=de5ee9e0&"
import script from "./HeaderControlsProject.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsProject.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports